import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { ResolverApiError } from './resolver-api.error';
import { ResolverApiResponse, ResolveUrlResponse } from './resolver-api.model';
import { RESOLVER_API_URL } from './resolver.tokens';

@Injectable({
  providedIn: 'root'
})
export class ResolverApiService {
  private http = inject(HttpClient);
  private readonly _baseApiUrl: string | null = inject(RESOLVER_API_URL);

  get baseApiUrl() {
    return this._baseApiUrl;
  }

  public resolveUrl(url: string): Observable<string> {
    return this.http
      .get<ResolverApiResponse<ResolveUrlResponse>>(`${this._baseApiUrl}resolve-url`, {
        params: new HttpParams({
          fromObject: {
            url
          }
        })
      })
      .pipe(
        catchError((data) => {
          return throwError(
            () =>
              new ResolverApiError({
                code: data.error.error.code,
                message: data.error.error.msg
              })
          );
        }),
        map((response) => {
          return response.data.pretty_url;
        })
      );
  }
}
